import apiClient from './apiClient';

export interface LabTestType {
    id: number;
    name: string;
    code: string;
    description?: string;
}

export interface LabTest {
    id: number;
    name: string;
    code: string;
    type_id: number;
    type?: LabTestType;
    description?: string;
    unit?: string;
    min_normal?: number;
    max_normal?: number;
    reference_range?: string;
}

export interface LabPanel {
    id: number;
    name: string;
    code: string;
    description?: string;
    tests?: LabTest[];
}

interface PaginatedData<T> {
    data: T[];
    pagination?: { current_page: number; last_page: number; total: number };
}

export const labTestService = {
    async search(query: string, typeId?: number): Promise<LabTest[]> {
        const params = new URLSearchParams();
        if (query) params.set('search', query);
        if (typeId) params.set('type_id', String(typeId));
        params.set('per_page', '30');

        const response = await apiClient.get<PaginatedData<LabTest>>(
            `/lab-tests?${params.toString()}`
        );
        return response.data.data;
    },

    async getById(id: number): Promise<LabTest> {
        const response = await apiClient.get<{ success: boolean; data: LabTest }>(
            `/lab-tests/${id}`
        );
        return response.data.data;
    },

    async getAll(): Promise<LabPanel[]> {
        const response = await apiClient.get<{ success: boolean; data: LabPanel[] }>(
            '/lab-panels?per_page=100'
        );
        return response.data.data;
    },

    async getPanels(): Promise<LabPanel[]> {
        const response = await apiClient.get<{ success: boolean; data: LabPanel[] }>(
            '/lab-panels?per_page=100'
        );
        return response.data.data;
    },

    async getPanelTests(panelId: number): Promise<LabTest[]> {
        const response = await apiClient.get<{ success: boolean; data: LabTest[] }>(
            `/lab-panels/${panelId}/tests`
        );
        return response.data.data;
    },
};

export default labTestService;